const { appendFilter } = require('../../../queries');
const addTransactionHistoryQueries = require('../../../queries/configs/TransactionHistory');

module.exports = addTransactionHistoryQueries(function ({ payerId, baseUrl }) {
  return ({
    baseUrl: `${baseUrl}/${payerId}/histtrans`,
    queriesFilter: appendFilter('payerId', payerId),
  })
});
